/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Print format of the <a href="https://docs.goshippo.com/docs/shipments/shippinglabelsizes/">label</a>. If empty, will use the default format set from
 *
 * @remarks
 * <a href="https://apps.goshippo.com/settings/labels">the Shippo dashboard.</a>
 */
export const LabelFileTypeEnum = {
  Png: "PNG",
  PNG23x75: "PNG_2.3x7.5",
  Pdf: "PDF",
  PDF23x75: "PDF_2.3x7.5",
  PDF4x6: "PDF_4x6",
  PDF4x8: "PDF_4x8",
  PdfA4: "PDF_A4",
  PdfA5: "PDF_A5",
  PdfA6: "PDF_A6",
  Zplii: "ZPLII",
} as const;
/**
 * Print format of the <a href="https://docs.goshippo.com/docs/shipments/shippinglabelsizes/">label</a>. If empty, will use the default format set from
 *
 * @remarks
 * <a href="https://apps.goshippo.com/settings/labels">the Shippo dashboard.</a>
 */
export type LabelFileTypeEnum = ClosedEnum<typeof LabelFileTypeEnum>;

/** @internal */
export const LabelFileTypeEnum$inboundSchema: z.ZodNativeEnum<
  typeof LabelFileTypeEnum
> = z.nativeEnum(LabelFileTypeEnum);

/** @internal */
export const LabelFileTypeEnum$outboundSchema: z.ZodNativeEnum<
  typeof LabelFileTypeEnum
> = LabelFileTypeEnum$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace LabelFileTypeEnum$ {
  /** @deprecated use `LabelFileTypeEnum$inboundSchema` instead. */
  export const inboundSchema = LabelFileTypeEnum$inboundSchema;
  /** @deprecated use `LabelFileTypeEnum$outboundSchema` instead. */
  export const outboundSchema = LabelFileTypeEnum$outboundSchema;
}
